import { render, staticRenderFns } from "./DetailImg.vue?vue&type=template&id=5d3b00f6&scoped=true"
import script from "./DetailImg.vue?vue&type=script&lang=js"
export * from "./DetailImg.vue?vue&type=script&lang=js"
import style0 from "./DetailImg.vue?vue&type=style&index=0&id=5d3b00f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3b00f6",
  null
  
)

export default component.exports